// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"507dd295","498":"56f1540d","616":"c4246536","672":"20ee599e","842":"3cdd5e39"}[chunkId] + ".chunk.js";
};